import React from 'react';
import { appTheme } from '../../../theme';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Container, PageHeader, SecondaryTitle } from '../../common';
import ChangePasswordForm from './ChangePasswordForm';
import NotificationSettingsForm from './NotificationSettingsForm';

const Instructions = styled.p`
  padding: ${appTheme.spacing.default} 0;
`;

const SubTitle = styled(SecondaryTitle)`
  border-color: ${appTheme.system.black};
  color: ${appTheme.system.black};
`;

class NotificationSettingsPage extends React.Component {
  componentDidMount() {
    return this.props
      .onMount()
      .catch(error => this.setState({ loadingError: error }));
  }

  render() {
    const {
      email,
      onChangePassword,
      onSaveNotifications,
      notificationSettings,
    } = this.props;
    return (
      <Container>
        <PageHeader title="Settings" />
        <SubTitle>Notifications</SubTitle>
        <Instructions>
          Select the types of notifications and prompts that you'd like to
          receive:
        </Instructions>
        <NotificationSettingsForm
          notificationSettings={notificationSettings}
          onCancel={this.handleCancel}
          onSave={onSaveNotifications}
        />
        <SubTitle>Update Password</SubTitle>
        <ChangePasswordForm email={email} onSave={onChangePassword} />
      </Container>
    );
  }
}

NotificationSettingsPage.propTypes = {
  email: PropTypes.string.isRequired,
  notificationSettings: PropTypes.object.isRequired,
  onChangePassword: PropTypes.func.isRequired,
  onMount: PropTypes.func.isRequired,
  onSaveNotifications: PropTypes.func.isRequired,
};

export default NotificationSettingsPage;



// WEBPACK FOOTER //
// ./src/modules/SettingsPage/components/SettingsPage.js